/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://ww2herullvaepnzrqh536xyxf4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-zo2jobrle5dhvhpwh5jxjbc62u",
    "aws_cognito_identity_pool_id": "us-east-1:d0bbcf20-5f71-45bc-a906-1750f49fc9c4",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_iOUM7bHxZ",
    "aws_user_pools_web_client_id": "67cdv1d6530ncfldik7h00fmm5",
    "oauth": {
        "domain": "unitedlabswebauth-dev.auth.us-east-1.amazoncognito.com"
    },
    "federationTarget": "COGNITO_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
